import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { login } from '../api'

export default function Login() {
  const nav = useNavigate()
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [err, setErr] = useState('')
  const [busy, setBusy] = useState(false)

  async function submit(e: React.FormEvent) {
    e.preventDefault()
    setBusy(true); setErr('')
    try {
      await login(email, password)
      nav('/fleet', { replace: true })
    } catch {
      // Not "no such user" vs "wrong password": that difference tells an
      // attacker which addresses are registered.
      setErr('Invalid email or password.')
    } finally { setBusy(false) }
  }

  return (
    <div className="login">
      <div className="aura" aria-hidden="true" />
      <div className="brand" style={{ padding: '0 0 6px' }}>
        <span className="dot" /> Therm
      </div>
      <p className="sub" style={{ marginBottom: 20 }}>Operations · staff sign-in</p>
      <form className="panel" onSubmit={submit}>
        {err && <div className="err">{err}</div>}
        <label htmlFor="email">Username or email</label>
        {/* type="text", not "email": the browser would otherwise reject a bare
            username as invalid before the form is ever submitted. */}
        <input id="email" type="text" autoComplete="username" required
               autoCapitalize="none" autoCorrect="off" spellCheck={false}
               autoFocus value={email} onChange={(e) => setEmail(e.target.value)} />
        <label htmlFor="pw">Password</label>
        <input id="pw" type="password" autoComplete="current-password" required
               value={password} onChange={(e) => setPassword(e.target.value)} />
        <button className="btn" disabled={busy || !email || !password}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
      </form>
      <p className="faint" style={{ textAlign: 'center', marginTop: 18,
                                    fontSize: 13 }}>
        This surface can read every customer&rsquo;s home. Sessions are short and
        every action is audited.
      </p>
    </div>
  )
}
